import _ = require('underscore');
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IDataSourceInfo } from '../../../../ts/models/IDataSourceInfo';
import { ConnectionEditabilityHelper } from '../../../../ts/services/EditConnectionAction';
import { changeExtractDsToLive } from '../../../actions/spaces/ChangeExtractDsToLiveAction';
import { selectSpaceInfo } from '../../../selectors/ContentSelectors';
import { AppState } from '../../../state/AppState';
import { isWorkbookSpace, SpaceInfo } from '../../../state/SpaceInfo';
import { getCommonDatasourceInfo } from '../../CommonDatasourceInfo';
import { IEntityAction } from './IEntityAction';

export function confirmAllExtractBasedDatasource(targetItems: IDataSourceInfo[]) {
  return _.any(targetItems, (targetItem) => targetItem.contentType === 'datasource' && targetItem.hasExtracts);
}

export const ChangeExtractDsToLiveAction: IEntityAction<IDataSourceInfo, {}> = {
  name: 'change_extract_ds_to_live',
  translateName: Messages.changeExtractDsToLiveAction,
  isVisible: (targetItems: IDataSourceInfo[], state: AppState) => {
    if(!FeatureFlags.extractMoveToTheWebEnabled || targetItems.length === 0){
      return false;
    }
    return confirmAllExtractBasedDatasource(targetItems);
  },
  isClickable: (availableActions: {}, content: IDataSourceInfo[], state: AppState) => {
    if(!FeatureFlags.extractMoveToTheWebEnabled || content.length === 0){
      return false;
    }
    const spaceInfo: SpaceInfo = selectSpaceInfo(state);
    // This button is clickable in two cases: 1. only 1 published ds is selected; 2. In workbook space
    return (content.length === 1 || isWorkbookSpace(spaceInfo)) &&
      _.any(content, contentItem => {
        return ConnectionEditabilityHelper.userCanEditDatasource(getCommonDatasourceInfo(contentItem), state);
      });
  },
  createReduxAction: (dataSources: IDataSourceInfo[]) => changeExtractDsToLive(dataSources)
};
